module.exports = __webpack_public_path__ + "img/car-home.f031c0ce.jpg";